module.exports = __webpack_public_path__ + "packs/media/images/Invitation_Triangle-22ec5c44d7a0f2fd76b165db9a52c69a.png";